import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function CompanyName(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (form.checkValidity() === false) {
      setValidated(false);
    } else {
      setValidated(true);
    }
  });

  return (
    <>
      <Row className="mb-2 justify-content-center">
        <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
        <Col md={6} style={{ maxWidth: "100%" }}>
          <p className="visby-bold f28 primary">What is the name of the company for this account?</p>
        </Col>
      </Row>
      <Row className="justify-content-center mb-5">
        <Col className="name-blurr" md={6}>
          <p className="nunito-regular f16 primary">
            This is how your name will be displayed in DataPulse. Just the simplest form <br></br> of your company name is ideal.
          </p>
        </Col>
      </Row>
      <Row className="justify-content-center pb-2">
        <Col className="name-input" md={6}>
          <Form.Control
            size="md"
            style={{ width: "591px", maxWidth: "100%", margin: "0 auto" }}
            value={props.companyName}
            maxLength="30"
            onChange={(e) => props.setCompanyName(e.target.value)}
            required
            type="text"
          />
          <Form.Control.Feedback>A company name is required</Form.Control.Feedback>
        </Col>
      </Row>
      <Row style={{ marginBottom: "100px" }} className="justify-content-center">
        <Col style={{ paddingLeft: "75px" }} md={6}>
          <p className=" nunito-regular f12 primary">Note: Avoid adding company type suffixes like "Inc" or "LLC" here (that's what the legal page is for!)</p>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col className="mr-4">
          <Row className="navButtonRow text-center">
            <Col>
              <BackButton />
              <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
              <NextButton
                validated={validated}
                btnText={`Next`}
                nextPage={nextPage.url}
                invalidText={`Company name must be entered`}
                submitForm={props.submitForm}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
